import { Navigate, useParams } from 'react-router-dom';
import { CustomizeModulePage } from '@platform/features/modules/CustomizeModulePage';
import { appRoutes } from '../../shell/appRoutes';
import { useCustomizationScope } from '../system/useCustomizationScope';
import { CustBuilderPage } from './CustBuilderPage';
import { CustFormsPage } from './CustFormsPage';
import { CustLayoutPage } from './CustLayoutPage';
import { CustLinksPage } from './CustLinksPage';
import { CustModulesPage } from './CustModulesPage';
import { CustPathsPage } from './CustPathsPage';
import { CustTagsPage } from './CustTagsPage';
import { GlobalCatalogPage } from './global/GlobalCatalogPage';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/**
 * /customize/:section[/:item] — розділ «Налаштування» (прототип v4 cust-mods, cust-forms, builder, settings › layout, areas, iterations,
 * tags, cust-links); невідомий розділ веде на огляд. Пункт «Форм» і «Встановлених модулів» (`:item` — ключ модуля) — редактор форми й
 * «Записи й форми» модуля в макеті «Налаштування» (прототип v4 cust-form / cust-module без inMod: меню «Налаштування», крихти
 * «… › Налаштування › Форми › Форма «Справа»», «← Форми» / «← Модулі»); рівень «Глобально» — «Каталог модулів» шаблонів (ADR-027),
 * крихта «Каталог модулів», глобальні форма й визначення модуля.
 */
export function CustomizeSectionPage() {
  const { section = '', item } = useParams();
  const { ws } = useWorkspaceParams();
  const global = useCustomizationScope(ws).scope === 'global';
  switch (section) {
    case 'modules': return item ? <CustomizeModulePage key={`${item}/${global}`} section="modules" global={global} /> : global ? <GlobalCatalogPage /> : <CustModulesPage />;
    case 'forms': return item ? <CustomizeModulePage key={`${item}/${global}`} section="forms" global={global} /> : <CustFormsPage />;
    case 'builder': return <CustBuilderPage />;
    case 'layout': return <CustLayoutPage />;
    case 'areas': return <CustPathsPage key="areas" kind="areas" />;
    case 'iterations': return <CustPathsPage key="iterations" kind="iterations" />;
    case 'tags': return <CustTagsPage />;
    case 'links': return <CustLinksPage />;
    default: return <Navigate to={appRoutes.customize()} replace />;
  }
}
